export default __webpack_public_path__ + "static/media/turkiyefinans.a8eaa505.png";